export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      tools = _ref.tools;
  return {
    /**
     * QC 质检列表（分页 + 筛选）
     * 返回 { content: [], totalElements, totalPages, number, size }
     */
    loadQcQuestionList: function loadQcQuestionList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/qc/questions',
        method: 'get',
        params: data
      });
    },

    /**
     * QC 单题完整信息（质检卡片）
     */
    getQcQuestion: function getQcQuestion(id) {
      return request({
        url: "/api/qc/questions/".concat(id),
        method: 'get'
      });
    },

    /**
     * QC 统计条 { total, pending, pass, fail, flagged, flagCounts }
     */
    getQcStats: function getQcStats() {
      return request({
        url: '/api/qc/stats',
        method: 'get'
      });
    },

    /**
     * QC 裁定：{ qcStatus: 'pass'|'fail'|'pending', qcNote, rejectReasonCodes: [] }
     * 判 fail 时后端联动把题目置 draft（不物理删除）
     */
    submitQcDecision: function submitQcDecision(id, data) {
      return request({
        url: "/api/qc/questions/".concat(id, "/decision"),
        method: 'post',
        data: data
      });
    },

    /**
     * 批量通过：带旗标的题目由服务端拒绝，返回 { passed: [], rejected: [{ id, flags }] }
     */
    batchPassQcQuestions: function batchPassQcQuestions(questionIds) {
      return request({
        url: '/api/qc/questions/batch/pass',
        method: 'post',
        data: {
          questionIds: questionIds
        }
      });
    },

    /**
     * 驳回原因码字典
     */
    getQcRejectReasons: function getQcRejectReasons() {
      return request({
        url: '/api/qc/reject-reasons',
        method: 'get'
      });
    },

    /**
     * 旗标元数据字典
     */
    getQcFlagMetas: function getQcFlagMetas() {
      return request({
        url: '/api/qc/flags/meta',
        method: 'get'
      });
    }
  };
});